/** Field of a page which contain all information about a breadcrumb. */
export type Breadcrumb = {
  label: string
  path: string
  slug: string
}
